<template>
  <div class="w-100 mt-5">
    <!-- <GMapMap
      :center="center"
      :zoom="14"
      map-type-id="terrain"
      ref="myMapRef"
      :cluster="{ options: { styles: clusterStyle } }"
      style="width: 500px; height: 300px"
      :options="{
        fullscreenControl: false,
        styles: mapStyle,
        mapTypeControl: false,
        streetViewControl: false,
        keyboardShortcuts: false,
        controlSize: 23,
      }"
    >
      <GMapCluster>
        <GMapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="true"
          @click="openInfoWindow(m.position)"
          :icon="require(`@/assets/images/paxel-marker.svg`)"
        />
      </GMapCluster>
    </GMapMap> -->
    <!-- <GMap
      ref="gMap"
      language="en"
      :cluster="{ options: { styles: clusterStyle } }"
      :center="location"
      :options="{
        fullscreenControl: false,
        styles: mapStyle,
        mapTypeControl: false,
        streetViewControl: false,
        keyboardShortcuts: false,
        controlSize: 23,
      }"
      :zoom="14"
      @loaded="onLoad"
    >
      <GMapMarker
        :position="location"
        :options="{
          icon: require('@/assets/images/paxel-marker.svg'),
          draggable: true,
          scale: 100,
        }"
        :button="changeLocation"
        @click="currentLocation = location"
        @dragend="dragFunct"
      >
        <GMapInfoWindow :options="{ maxWidth: 200 }">
          <button @click="changeLocation()">Pilih lokasi ini</button>
        </GMapInfoWindow>
      </GMapMarker>
      <GMapCircle :options="circleOptions" />
    </GMap> -->
    <!-- <MenuNavbar :taboption="taboption" />
    <br />
    <div class="row">
      <div class="col-3 col-md-3 col-lg-3 col-xl-3">
        <CardInfo title="Net Sales" :cardData="dataApi[0]" />
      </div>
      <div class="col-3 col-md-3 col-lg-3 col-xl-3">
        <CardInfo title="Total Commission" :cardData="dataApi[1]" />
      </div>
      <div class="col-3 col-md-3 col-lg-3 col-xl-3">
        <CardInfo title="New Seller Signup" :cardData="dataApi[2]" />
      </div>
      <div class="col-3 col-md-3 col-lg-3 col-xl-3">
        <CardInfo title="New Product" :cardData="dataApi[3]" />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-6 bg-white">
        <ChartBar
          :chartData="chartOrder.chartData"
          :options="chartOrder.options"
          :dataName="'chartOrder'"
        />
      </div>
      <div class="col-6 bg-white">
        <ChartBar
          :chartData="chartRevenue.chartData"
          :options="chartRevenue.options"
          :dataName="'chartRevenue'"
        />
      </div>
    </div>
    <br />
    <div>
      <TableBasic :payload="payload" />
    </div> -->
  </div>
</template>

<script>
// import TableBasic from "@/components/TableBasic.vue";
// import ChartBar from "@/components/ChartBar.vue";
// import MenuNavbar from "@/components/global/MenuNavbar.vue";
// import DatePicker from "@/components/DatePicker.vue";
// import Select from "@/components/Select.vue";
// import TextEditor from "@/components/TextEditor.vue";
// import QuilTextEditor from "@/components/QuilTextEditor.vue";

// import { shallowRef } from "vue";
// const Home = shallowRef(TableBasic);
// const About = shallowRef(TableBasic);
export default {
  data() {
    return {
      center: { lat: -6.2, lng: 106.8456 },
      markers: [
        {
          position: {
            lat: -6.2,
            lng: 106.8456,
          },
        }, // Along list of clusters
      ],
      mapStyle : [],
      clusterStyle: [
        {
          url: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png",
          width: 56,
          height: 56,
          textColor: "#fff",
        },
      ],
      taboption: [
        {
          name: "Realtime",
          component: "",
          payload: {},
        },
        {
          name: "Today",
          component: "",
          payload: {},
        },
        {
          name: "This Week",
          component: "",
          payload: {},
        },
        {
          name: "30 Days",
          component: "",
          payload: {},
        },
      ],

      chartOrder: {
        chartData: {
          labels: [
            "01/02",
            "02/02",
            "03/02",
            "04/02",
            "05/02",
            "06/02",
            "07/02",
          ],
          datasets: [
            {
              type: "line",
              label: "Total Order ",
              data: [35, 40, 44, 50, 47, 32, 39],
              borderWidth: 3,
              fill: true,
              backgroundColor: "rgba(255, 178, 0, 0.5)",
              backgroundColor2: "rgba(255, 178, 0, 0.2)",
              backgroundColor3: "rgba(255, 178, 0, 0)",
              pointBackgroundColor: "#FFF",
              pointBorderWidth: 2,
              borderColor: "#FFB003",
              opacity: 0.1,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: "Orders within 7 Days",
              align: "left",
              color: "#5E50A1",
              fontSize: 20,
            },
          },
          scales: {
            x: {
              grid: {
                lineWidth: 0,
                color: "rgba(255,0,0,0.1)",
                borderColor: "#FF434F",
                borderWidth: 4,
              },
            },
            y: {
              min: 0,
              ticks: {
                stepSize: 10,
              },
            },
          },
        },
      },

      chartRevenue: {
        chartData: {
          labels: [
            "01/02",
            "02/02",
            "03/02",
            "04/02",
            "05/02",
            "06/02",
            "07/02",
          ],
          datasets: [
            {
              type: "line",
              label: "Total Revenue ",
              data: [600000, 750000, 800000, 1000000, 900000, 550000, 730000],
              borderWidth: 3,
              fill: true,
              backgroundColor: "rgba(48, 203, 157, 0.5)",
              backgroundColor2: "rgba(48, 203, 157, 0.2)",
              backgroundColor3: "rgba(48, 203, 157, 0)",
              pointBackgroundColor: "#FFF",
              pointBorderWidth: 2,
              borderColor: "#30CB9D",
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: "Revenue within 7 Days",
              align: "left",
              color: "#5E50A1",
              fontSize: 20,
            },
          },
          scales: {
            x: {
              grid: {
                lineWidth: 0,
                color: "rgba(255,0,0,0.1)",
                borderColor: "#FF434F",
                borderWidth: 4,
              },
            },
            y: {
              min: 0,
              ticks: {
                stepSize: 250000,
              },
            },
          },
        },
      },

      array: ["array1", "array2"],
      dataApi: [
        {
          percentage: 5.4,
          value: 567890000,
          color: "primary",
          url: "netSales",
        },
        {
          percentage: 3.1,
          value: 123013511,
          color: "primary",
          url: "netSales",
        },
        {
          percentage: 16,
          value: 234,
          color: "secondary",
          url: "netSales",
        },
        {
          percentage: -12,
          value: 86,
          color: "secondary",
          url: "netSales",
        },
      ],

      configDatepicker: {
        autoApply: true,
        enableTimePicker: false,
        range: false, //single date or range date
        minRange: null, //range need to set to be true
        maxRange: null, //range need to set to be true
        format: "yyyy-MM-dd", //if range change to two format example MM/dd/yyyy HH:mm - MM/dd/yyyy HH:mm:
        placeholder: "Select Date",
        readonly: false,
        required: false,
        name: "datepicker",
        uid: "datepicker1",
        autocomplete: "off", //prevent cache on input to show
        minDate: new Date(), //example : new Date() -> min date can be choose is today
        maxDate: null,
        position: "center", //'left' | 'center' | 'right'
      },
      configSelect: {
        multiple: false,
        placeholder: "-Select-",
        readonly: true,
        required: true,
        name: "select_example",
        uid: "select_example1", //select using dp-input-${uid}
        autocomplete: "off", //prevent cache on input to show
      },
      payload: {
        header: [
          {
            key: "product_sku",
            label: "Product SKU",
            class: "text-center",
          },
          {
            key: "product_name",
            label: "Product Name",
            class: "text-center",
          },
          {
            key: "seller",
            label: "Seller",
            class: "text-center",
          },
          {
            key: "stock",
            label: "Stock",
            class: "text-center",
          },
          {
            key: "view",
            label: "View",
            class: "text-center",
          },
          {
            key: "sold",
            label: "Sold",
            class: "text-center",
          },
          {
            key: "net_sale",
            label: "Net Sale",
            class: "text-center",
          },
        ],
        value: [
          {
            product_sku: "WYG01-A01",
            product_name: "BASO NURLELA TASIKMALAYA - BASO SAPI",
            seller: "BASO NURLELA TASIKMALAYA",
            stock: "102",
            view: "981",
            sold: "506",
            net_sale: "RP87.650.000",
          },
          {
            product_sku: "WYG01-A01",
            product_name: "BASO NURLELA TASIKMALAYA - BASO SAPI",
            seller: "BASO NURLELA TASIKMALAYA",
            stock: "102",
            view: "981",
            sold: "506",
            net_sale: "RP87.650.000",
          },
          {
            product_sku: "WYG01-A01",
            product_name: "BASO NURLELA TASIKMALAYA - BASO SAPI",
            seller: "BASO NURLELA TASIKMALAYA",
            stock: "102",
            view: "981",
            sold: "506",
            net_sale: "RP87.650.000",
          },
          {
            product_sku: "WYG01-A01",
            product_name: "BASO NURLELA TASIKMALAYA - BASO SAPI",
            seller: "BASO NURLELA TASIKMALAYA",
            stock: "102",
            view: "981",
            sold: "506",
            net_sale: "RP87.650.000",
          },
          {
            product_sku: "WYG01-A01",
            product_name: "BASO NURLELA TASIKMALAYA - BASO SAPI",
            seller: "BASO NURLELA TASIKMALAYA",
            stock: "102",
            view: "981",
            sold: "506",
            net_sale: "RP87.650.000",
          },
          {
            product_sku: "WYG01-A01",
            product_name: "BASO NURLELA TASIKMALAYA - BASO SAPI",
            seller: "BASO NURLELA TASIKMALAYA",
            stock: "102",
            view: "981",
            sold: "506",
            net_sale: "RP87.650.000",
          },
          {
            product_sku: "WYG01-A01",
            product_name: "BASO NURLELA TASIKMALAYA - BASO SAPI",
            seller: "BASO NURLELA TASIKMALAYA",
            stock: "102",
            view: "981",
            sold: "506",
            net_sale: "RP87.650.000",
          },
          {
            product_sku: "WYG01-A01",
            product_name: "BASO NURLELA TASIKMALAYA - BASO SAPI",
            seller: "BASO NURLELA TASIKMALAYA",
            stock: "102",
            view: "981",
            sold: "506",
            net_sale: "RP87.650.000",
          },
          {
            product_sku: "WYG01-A01",
            product_name: "BASO NURLELA TASIKMALAYA - BASO SAPI",
            seller: "BASO NURLELA TASIKMALAYA",
            stock: "102",
            view: "981",
            sold: "506",
            net_sale: "RP87.650.000",
          },
          {
            product_sku: "WYG01-A01",
            product_name: "BASO NURLELA TASIKMALAYA - BASO SAPI",
            seller: "BASO NURLELA TASIKMALAYA",
            stock: "102",
            view: "981",
            sold: "506",
            net_sale: "RP87.650.000",
          },
        ],
        totalRows: 10,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
      },
    };
  },
  components: {
    // GMap,
    // GMapMarker,
    // GMapInfoWindow,
    // GMapCircle,
    // MenuNavbar,
    // ChartBar,
    // DatePicker,
    // Select,
    // TextEditor,
    // QuilTextEditor,
    // TableBasic,
  },
  methods: {
    openInfoWindow(val) {
      this.center = val;
      console.log(val);
    },
  },
};
</script>

<style>
.custom-map-control-button {
  background-color: #fff;
  border: 0;
  border-radius: 2px;
  box-shadow: 0 1px 4px -1px rgba(0, 0, 0, 0.3);
  margin: 10px;
  padding: 0.6em 0.5em 0em 2.5em;
  height: 25px;
  width: 137px;
  background-repeat: no-repeat;
  background-size: 15px;
  background-position: 7px;
  cursor: pointer;
  border-radius: 10px;
  font-family: "Rubik";
  font-size: 11px;
}
.custom-map-control-button:hover {
  background-color: #ebebeb;
  color: #000;
}
a[href^="http://maps.google.com/maps"]
{
  display: none !important;
}
a[href^="https://maps.google.com/maps"]
{
  display: none !important;
}

.gmnoprint a,
.gmnoprint span,
.gm-style-cc {
  display: none;
}
input:checked ~ .dot {
  transform: translateX(130%);
  background-color: #ffff;
}
input:checked ~ .block {
  /* transform: translateX(130%); */
  background-color: #ed413f !important;
}
.gm-ui-hover-effect {
  display: none !important;
}
.gm-style .gm-style-iw-t::after {
  display: none !important;
}
.gm-style .gm-style-iw-d::-webkit-scrollbar-track,
.gm-style .gm-style-iw-d::-webkit-scrollbar-track-piece,
.gm-style .gm-style-iw-c,
.gm-style .gm-style-iw-t::after {
  background: #ee3f3d;
  color: white;
}
.gm-style .gm-style-iw-c {
  padding: 8px;
}
.gm-style .gm-style-iw-d {
  overflow: hidden !important;
  padding: 0px 8px 8px 0px;
}
.button-current-location {
  cursor: pointer;
}
</style>
